import { getCart } from '@/js/api/cart.ts';
import { getClient } from '@/js/api/client.ts';
import { getDeliveryData, getPickupData } from '@/js/api/order.ts';
import { getYandexSplitConfig } from '@/js/api/payment.ts';
import { SPINNER_CLASS } from '@/js/cart.ts';
import AppCheckout from '@/js/vue/checkout/app-checkout.vue';
import { createApp } from 'vue';

const CHECKOUT_SELECTOR = '.vue-checkout';
const checkoutElement = document.querySelector(CHECKOUT_SELECTOR);

export async function initCheckout() {
  if (!checkoutElement)
    return;
  try {
    const deliveryData = await getDeliveryData();
    const client = await getClient();
    const { data } = await getCart();
    const pickup = await getPickupData();
    const yandexSplit = await getYandexSplitConfig();
    const app = createApp(AppCheckout, {
      deliveryPricing: deliveryData.data,
      client: client.data,
      cart: data,
      pickupPrice: pickup.data?.price ?? 0,
      pickupAddress: pickup.data?.address ?? '',
      yandexSplit: yandexSplit.data,
    });
    app.mount(checkoutElement);
    checkoutElement.classList.remove(SPINNER_CLASS);
  }
  catch (e) {
    console.log(e);
  }
}
